import type { JSX } from 'react'
import type { IPopupProps } from '../Popup'

import { Popup } from '../Popup'
import { PopupPaddings, PopupRowGap } from '../Popup.h'

export interface IAuthPopupProps extends IPopupProps {}

export const AuthPopup = ({
  children,
  width = '520px',
  padding = PopupPaddings.SIZE_50,
  rowGap = PopupRowGap.INDENT_20,
  isCloseBtnShown = false,
  ...rest
}: IAuthPopupProps): JSX.Element => (
  <Popup
    width={width}
    padding={padding}
    rowGap={rowGap}
    isCloseBtnShown={isCloseBtnShown}
    {...rest}
  >
    {children}
  </Popup>
)
